import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import Sidebar from "../../components/sidebar/sidebar";
import TrainingCardCarousel, { ProductType } from "../../components/cards/trainingCards/trainingCardCarousel";
import { useCourses } from "../../hooks/useCourses";
import useHighlightCurrentMenuItem from "../../hooks/useHighlightCurrentMenuItem";
import { useNavigate } from "react-router";
import { Stats } from "fs";
import StatsPanel from "../../components/cards/statsPanel/statsPanel";
import BreadcrumbsNav from "../../components/navigation/breadcrumbs-nav/BreadcrumbsNav";
import type { BreadcrumbItem } from "../../components/navigation/types/BreadcrumbItem";



const DashboardPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [
    filterData,
    loaded,
    courses,
    handleFilterTypeCheckboxChange,
    handleFilterCheckboxChange,
    selectedFilters,
    handleResetFilter,
  ] = useCourses();


  
  

  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offsetWidth, setOffsetWidth] = useState<number>(0);

  const navigate = useNavigate();
  
  useHighlightCurrentMenuItem('/my-game')

  const [gridOneMdSize, setGridOneMdSize] = useState(6.6);
  const [gridTwoMdSize, setGridTwoMdSize] = useState(5.4);
  const [realCoursesLength, setRealCoursesLength] = useState<number>(0);
  let purchasedCourse = 0;
  courses.forEach((section) => {
    if (section.name.endsWith('\'s Training Programs')) {
      purchasedCourse = section.things.length;
    }
  })
  const handleClick = (): void => {
    window.location.href = window.location.origin;
  };
  const breadcrumbItems: readonly BreadcrumbItem[] = [
    { label: 'Training', onClick: handleClick },
    { label: 'My Game' },
  ];
  
  const updateContainerWidth = () => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };
  useEffect(() => {
    const length = courses.reduce((count, course) => {
      return course.things.length !== 0 ? count + 1 : count;
    }, 0);

    setRealCoursesLength(length);
  }, [courses])
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        updateContainerWidth(); // Call the function to update container width
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
      updateContainerWidth(); // Call the function to update container width initially
    }

    return () => {
      observer.disconnect();
    };
  }, [containerRef.current]);

  useEffect(() => {
    console.log("Offset width changed:", offsetWidth); // Log offsetWidth changes
    // Trigger the useEffect whenever the offsetWidth changes
    setTimeout(() => {
      updateContainerWidth(); // Call the function to update container width
    }, 1000);
  }, [offsetWidth]);

  

  return (
    <Box sx={{ overflowX: "hidden", margin: "0 auto" }} id="mainBox" className="maxWidthOverflow" ref={containerRef}>
 
      <Box className="coursesMargin" sx={{ marginTop: "30px" }}>
        <BreadcrumbsNav items={breadcrumbItems} separator="/" prefix="/" showIcon={true} />
      </Box>
      <Box className="coursesMargin">
        <Typography
          variant="h1"
          sx={{
            marginTop: "16px",
            marginBottom: "-10px",
            lineHeight: 1,
            fontWeight: 600,
            fontSize: "28px",
            [theme.breakpoints.down(900)]: {
              marginTop: "20px",

            },
          }}
          className="dashboardTitle"
        >
          My Game
        </Typography>
      </Box>

      <Box
        className="coursesMargin dashboardSubTitleContainer"
        sx={{

          display: "flex",
          alignItems: "center",
          [theme.breakpoints.down(900)]: {
            marginTop: "40px",

            marginBottom: "10px",
          },
        }}
      >
        <img
          src="https://members.performancegolf.com/wp-content/uploads/2025/04/trainingIcon.png"
          alt=""
          style={{ marginRight: "10px" }}
        />
        <Typography
          variant="h2"
          sx={{
            lineHeight: 1,
            fontWeight: 600,
            fontSize: "22px",
            [theme.breakpoints.down(900)]: {
              fontSize: "17px",
              lineHeight: "19px",
              fontWeight: 800,
            },
          }}
          className="dashboardSubTitle"
        >
          Training Programs ({purchasedCourse} Purchased)
        </Typography>
      </Box>

      <Grid container spacing={2}
        className="dashboardMainContainerParent">
        <Grid
          item
          md={gridOneMdSize}
          lg={gridOneMdSize}
          xl={gridOneMdSize}
          xs={12}
          sx={{ height: isMobile ? (realCoursesLength >= 2 ? "1200px" : realCoursesLength === 1 ? "auto" : "805px") : "auto" }}
          className="dashboardMainContainer"
        >
          {courses.map((course, index) => (
            <div
              key={index}
              className="carouselAndTitleAndArrowsContainer"
            >
              <div className="dashboardTrainingCarousel">
                <TrainingCardCarousel
                  items={course.things}
                  carouselTitle={course.name}
                  width={containerWidth}
                  parentPage={"dash"}
                  isSidebarOpen={false}
                  locationValue="Dashboard"
                />
              </div>
            </div>
          ))}
          {courses && (
            <div className="viewAllCoursesButtonContainer df jcfe">
              <a href="/courses" className="viewAllCoursesButton">
                View All
              </a>
            </div>
          )}
        </Grid>
        <Grid
          item
          md={gridTwoMdSize}
          lg={gridTwoMdSize}
          xl={gridTwoMdSize}
          xs={12}
          className="dashboardSidebar"
        >
          <Sidebar />
        </Grid>
      </Grid >
    </Box >
  );
};

export default DashboardPage;
